import { useContent } from "@/context/ContentContext";

export default function Marquee({ items }) {
  const c = useContent();
  const list = items || c.marqueeItems;
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/[0.07] py-6 bg-ink/40">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center">
            {list.map((text, i) => (
              <span key={i} className="flex items-center">
                <span className="font-serif italic font-light text-2xl md:text-4xl text-bone/90 px-8">
                  {text}
                </span>
                <span className="text-bronze text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
